var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: none;\n        stroke: #D6CCFF;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 8,
    r: 1.98
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.88,9.98c-.18.41-.09.88.22,1.2l.04.04c.52.51.52,1.35,0,1.86h0c-.51.52-1.35.52-1.86,0h0s-.04-.04-.04-.04c-.32-.31-.79-.4-1.2-.22-.4.17-.66.56-.66,1v.11c0,.73-.59,1.32-1.32,1.32s-1.32-.59-1.32-1.32v-.06c-.01-.45-.29-.84-.71-1-.41-.18-.88-.09-1.2.22l-.04.04c-.51.52-1.35.52-1.86,0,0,0,0,0,0,0-.52-.51-.52-1.35,0-1.86,0,0,0,0,0,0l.04-.04c.31-.32.4-.79.22-1.2-.17-.4-.56-.66-1-.66h-.11c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32h.06c.45-.01.84-.29,1-.71.18-.41.09-.88-.22-1.2l-.04-.04c-.52-.51-.52-1.35,0-1.86,0,0,0,0,0,0,.51-.52,1.35-.52,1.86,0,0,0,0,0,0,0l.04.04c.32.31.79.4,1.2.22h.05c.4-.17.66-.56.66-1v-.11c0-.73.59-1.32,1.32-1.32s1.32.59,1.32,1.32v.06c0,.43.26.82.66,1,.41.18.88.09,1.2-.22l.04-.04c.51-.52,1.35-.52,1.86,0,0,0,0,0,0,0,.52.51.52,1.35,0,1.86,0,0,0,0,0,0l-.04.04c-.31.32-.4.79-.22,1.2v.05c.17.4.56.66,1,.66h.11c.73,0,1.32.59,1.32,1.32s-.59,1.32-1.32,1.32h-.06c-.43,0-.82.26-1,.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.3b7a35ef546be6742acf6afdbe12c8d5.svg";
export { ForwardRef as ReactComponent };